export default __webpack_public_path__ + "static/media/app.09efcc35.png";